module.exports = __webpack_public_path__ + "img/safari.59077f93.gif";